import React from "react";
import styled from "styled-components";
import EditAndDelete from "../EditAndDelete";
import { Typography, Button } from "@mui/material";
import QuestionImage from "./QuestionImage";

const AnswerButtonFalse = styled(Button)`
  min-width: 70px;
  min-height: 30px;
  font-size: 14px;
  padding: 5px;
  background-color: ${(props) => props.theme.palette.info.light};
  color: black;

  &:hover {
    background-color: ${(props) => props.theme.palette.info.light};
  }

  &:disabled {
    background-color: #ebf5fe;
  }
`;

const AnswerButtonTrue = styled(Button)`
  min-width: 70px;
  min-height: 30px;
  font-size: 14px;
  padding: 5px;
  color: black;
  background-color: ${(props) => props.theme.palette.info.light};
  &:hover {
    background-color: ${(props) => props.theme.palette.info.light};
  }

  &:disabled {
    background-color: #ebf5fe;
  }
`;

const ButtonHolder = styled.div`
  height: 100%;
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-bottom: 8px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 4px;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

const Separate = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 34px;
  width: 100%;
`;

const QuestionDetailsTF = ({
  question,
  handleDeleteQuestion,
  builderContext,
  isReview = false,
  isModuleLive,
  isModuleConvertingNextStateLive,
  isModulePending,
  isModuleConvertingNextStatePending,
  isModuleInReview,
  isModuleConvertingNextStateReview,
}) => (
  <Wrapper>
    <Typography
      style={{
        fontSize: 10,
        fontWeight: "500",
        color: "darkgrey",
        whiteSpace: "nowrap",
        alignSelf: "flex-start",
      }}
    >
      True / False
    </Typography>
    <div style={{ height: 8 }} />

    <ButtonHolder>
      <AnswerButtonTrue disabled={question.correctAnswer !== "True"}>
        True
      </AnswerButtonTrue>
      <AnswerButtonFalse disabled={question.correctAnswer === "True"}>
        False
      </AnswerButtonFalse>
    </ButtonHolder>
    <div style={{ height: 16 }} />

    {!isReview && (
      <Separate>
        <div
          style={{
            minWidth: 200,
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <span
            style={{
              fontSize: 11,
              color: "black",
              whiteSpace: "nowrap",
              fontWeight: "600",
            }}
          >
            Correct Answer: {"  "}
            {question.correctAnswer === "True" ? "True" : "False"}
          </span>
        </div>
        <EditAndDelete
          builderContext={builderContext}
          handleDeleteQuestion={handleDeleteQuestion}
          question={question}
          deleteDisabled={
            isModuleLive ||
            isModuleInReview ||
            isModulePending ||
            isModuleConvertingNextStateReview ||
            isModuleConvertingNextStateLive ||
            isModuleConvertingNextStatePending
          }
        />
      </Separate>
    )}
  </Wrapper>
);

export default QuestionDetailsTF;
